import { render, staticRenderFns } from "./nameBirthdayGender.vue?vue&type=template&id=102710b7&"
import script from "./nameBirthdayGender.vue?vue&type=script&lang=ts&"
export * from "./nameBirthdayGender.vue?vue&type=script&lang=ts&"
import style0 from "./nameBirthdayGender.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports